/**
 * Shared geometry for the BTP card overlay and image cropping.
 * Used by LiveQrScanner (camera overlay) and imagePreprocess (crop regions).
 * Card reference: 85.6 × 54 mm; overlay is 90% viewport width, aspect ratio 1.6.
 */

/** Max dimension for canvas/processing (OCR, QR). */
export const MAX_CANVAS_SIZE = 1920;

/** Card width as fraction of viewport/image width (center-aligned). */
export const CARD_WIDTH_PCT = 0.9;

/** Card aspect ratio: width / height. */
export const CARD_RATIO = 1.6;

/** QR zone: square side as fraction of card height (bottom-right). */
export const QR_ZONE_SIZE_PCT = 0.38;

/** OCR zone: left margin as fraction of card width. */
export const OCR_LEFT_MARGIN_PCT = 0.1;

/** OCR zone: height as fraction of card height (bottom half). */
export const OCR_HEIGHT_PCT = 0.5;

/** 3 mm as fraction of card width (card ref 85.6 mm). QR left edge and OCR right edge shift by this. */
export const BORDER_SHIFT_PCT = 3 / 85.6;

/** OCR zone width as fraction of card: from left margin to just left of QR zone. */
export const OCR_ZONE_WIDTH_PCT =
  1 - OCR_LEFT_MARGIN_PCT - QR_ZONE_SIZE_PCT / CARD_RATIO - BORDER_SHIFT_PCT;

/** QR zone width as fraction of card: square + extension to the left. */
export const QR_ZONE_WIDTH_PCT = QR_ZONE_SIZE_PCT / CARD_RATIO + BORDER_SHIFT_PCT;
